import { render, staticRenderFns } from "./indicators.vue?vue&type=template&id=62dc8c2d&scoped=true"
import script from "./indicators.vue?vue&type=script&lang=js"
export * from "./indicators.vue?vue&type=script&lang=js"
import style0 from "./indicators.vue?vue&type=style&index=0&id=62dc8c2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dc8c2d",
  null
  
)

export default component.exports